export default "__VITE_ASSET__eakD8GS1__"